import { useGlobalState, useResponsive } from '@/hooks';
import { ResponsiveCollection } from '@/interfaces';
import type { IPmtOnboardingPopup } from '@/modules/pmt/interfaces';
import Image from 'next/image';

export const HeroImage: React.FC<IPmtOnboardingPopup> = ({ heroImage, loginByEmail }) => {
  const { isDesktopPMT } = useResponsive([ResponsiveCollection.DesktopPMT]);
  const { getProperImageUrl } = useGlobalState();

  if (!heroImage?.url) return null;

  const imageProps = {
    src: getProperImageUrl(heroImage),
    alt: heroImage.title || heroImage.description || 'Banner',
  };

  if (isDesktopPMT) {
    return (
      <Image
        {...imageProps}
        width={288}
        height={545}
        style={{
          objectFit: 'cover',
        }}
      />
    );
  }

  // Facing issue in mobile if loginByEmail is true (email form makes the popup too long), so hide the hero image for now
  if (loginByEmail) return null;

  return (
    <Image
      {...imageProps}
      sizes='100vw'
      width={0}
      height={247}
      style={{
        width: '100%',
        objectFit: 'cover',
      }}
    />
  );
};
